module.exports = __webpack_public_path__ + "static/media/logo-civa.ccbba419.png";